import React from 'react'
import { Button, ButtonGroup } from 'rsuite'
import Icon from './Icon'

/**
 * Choose one of a few views with a row of joined buttons, the chosen one filled
 * @param {Object} props component props
 * @param {Array<{ value: string, label: string, icon: string }>} props.options views to choose from
 * @param {string} props.selected value of the chosen view
 * @param {Function|null} props.onChange called with the value of the clicked view
 * @param {string} props.className extra class name
 * @returns {JSX.Element} button group
 */
const SegmentedToggle = ( { options = [], selected = '', onChange = null, className = '' } ) =>
(
  <ButtonGroup className={ `segmented-toggle ${ className }` }>
    { options.map( option => (
      <Button
        key={ option.value }
        appearance={ option.value === selected ? 'primary' : 'default' }
        aria-pressed={ option.value === selected }
        aria-label={ option.label }
        title={ option.label }
        onClick={ () => onChange && option.value !== selected && onChange( option.value ) }
      >
        <Icon icon={ option.icon }/> <span className="label">{ option.label }</span>
      </Button>
    ) ) }
  </ButtonGroup>
)

export default SegmentedToggle
